import retrieveArticle from '@/actions/retrieve-article';

interface HtmlViewerProps {
  linkId: string;
}

const HtmlViewer = async ({ linkId }: HtmlViewerProps) => {
  try {
    const article = await retrieveArticle({ linkId });
    return article;
  } catch (error) {
    console.error('Error fetching HTML:', error);
    return '<p>Error loading content</p>';
  }
};

export default HtmlViewer;
